import { Icon } from "@chakra-ui/react";
import React from "react";

const ArrowIcon = (props) => (
  <Icon viewBox="0 0 12 8" {...props}>
    <path d="M6 7.4L0 1.4L1.4 0L6 4.575L10.6 0L12 1.4L6 7.4Z" fill="currentColor" />
  </Icon>
);

export default React.memo(ArrowIcon);
